import type { HeadersFunction, LoaderArgs, MetaFunction } from "@remix-run/node";
import { json } from "@remix-run/node";
import { useLoaderData } from "@remix-run/react";
import clsx from "clsx";
import { fetchEventV2 } from "@/lib/microcms.server";
import { CacheRevalidateMinutes, notFound } from "@/lib/responses.server";
import { createOGP } from "@/utilities/ogp";
import common from "@/data/common.json";
import { PageContainer } from "@/components/PageContainer";
import { ArticleLayout } from "@/components/ArticleLayout";
import { EventsArticle } from "@/components/Events/Article";
import { SNSShareSection } from "@/components/SNSShareSection";

export const meta: MetaFunction<typeof loader> = ({ data }) => {
  return createOGP({ path: `${common.meta.url}/events/${data?.post.id}`, pageName: data?.post.title });
};

export const headers: HeadersFunction = () => {
  return {
    "Cache-Control": CacheRevalidateMinutes(),
  };
};

export async function loader({ params }: LoaderArgs) {
  const id = params.id!;

  const post = await fetchEventV2(id).catch(() => null);
  if (!post || !post.reservation_status.includes("一般公開")) {
    throw notFound();
  }

  return json({ post, canonical: `${common.meta.url}/events/article/${post.id}` });
}

export default function EventArticle() {
  const { post } = useLoaderData<typeof loader>();
  const shareURL = `${common.meta.url}/events/article/${post.id}`;
  const shareText = `${post.title} / ${common.meta.title}`;

  return (
    <PageContainer>
      <ArticleLayout
        paths={[
          { name: "ホーム", url: "/" },
          { name: "イベントスケジュール一覧", url: "/events" },
          { name: post.title, url: `/events/article/${post.id}` },
        ]}
      >
        <div className={clsx("flex", "flex-col", "space-y-8")}>
          <EventsArticle post={post} shareURL={shareURL} shareText={shareText} />
          <hr />
          <SNSShareSection url={shareURL} text={shareText} />
        </div>
      </ArticleLayout>
    </PageContainer>
  );
}
